import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "./zh/index";
import en from "./en/index";

Vue.use(VueI18n);

const messages = {
  zh: {
    ...zh
  },
  en: {
    ...en
  }
};
const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "zh",
  messages
});

export default i18n;



// WEBPACK FOOTER //
// ./src/assets/lang/index.js